import Button from '@rio-cloud/rio-uikit/Button';
import ButtonDropdown, { type ButtonDropdownProps } from '@rio-cloud/rio-uikit/ButtonDropdown';
import type { MenuItemProps } from '@rio-cloud/rio-uikit/MenuItem';
import { useIntl } from 'react-intl';

import { useFeatureToggle } from '#configuration/featureFlags/useFeatureToggle.ts';
import type { OrderType } from '#domain/Order.ts';

type Props = {
    title: string;
    onSelect: (type: OrderType) => void;
    bsStyle?: ButtonDropdownProps['bsStyle'];
    id?: string;
};

export const CreateOrderButton = ({ title, onSelect, bsStyle = Button.PRIMARY, id }: Props) => {
    const intl = useIntl();
    const showServiceOrders = useFeatureToggle('showServiceOrders', false);
    const items: MenuItemProps[] = [
        {
            value: (
                <span className='display-flex align-items-center gap-5'>
                    <span className='uikit-icon icon-truck' />
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.order.type.transport',
                        defaultMessage: 'Transport',
                    })}
                </span>
            ),
            onSelect: () => onSelect('transport'),
        },
        {
            value: (
                <span className='display-flex align-items-center gap-5'>
                    <span className='uikit-icon icon-wrench' />
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.order.type.service',
                        defaultMessage: 'Service',
                    })}
                </span>
            ),
            onSelect: () => onSelect('service'),
        },
    ];

    return showServiceOrders ? (
        <ButtonDropdown
            id={id}
            title={<span>{title}</span>}
            bsStyle={bsStyle}
            dropdownClassName='white-space-nowrap'
            items={items}
        />
    ) : (
        <Button
            bsStyle={bsStyle}
            iconName='plus'
            autoTrackingKey='intl-msg:ordercom-cloud-frontend.orders.create-dialog.title'
            onClick={() => onSelect('transport')}
        >
            {title}
        </Button>
    );
};
